import * as React from 'react';
import SidebarLink from './sidebar-link';
import SidebarCategory from '../../../../../theme/pages/_layout/topbar_with_navigation/sidebar_mobile/SidebarCategory';

interface SidebarContentProps {
    onClick();
}

class SidebarContent extends React.PureComponent<SidebarContentProps> {

    private hideSidebar = () => {
        this.props.onClick();
    };

    public render() {
        return (
            <div className='sidebar__content'>
                <ul className='sidebar__block'>
                    <SidebarLink title='Portada' icon='laptop' route='/portada' onClick={this.hideSidebar}/>
                    <SidebarCategory title='Avances de Venta' icon='layers'>
                        <ul className='sidebar__block'>
                            <SidebarLink title='Comparativo Anual' route='/avances/anual'
                                         onClick={this.hideSidebar}/>
                        </ul>
                    </SidebarCategory>
                    <SidebarLink title='Coberturas' icon='layers' route='/coberturas' onClick={this.hideSidebar}/>
                    <SidebarCategory title='Prioritarios' icon='layers'>
                        <ul className='sidebar__block'>
                            <SidebarLink title='Gloria' route='/prioritarios/gloria' onClick={this.hideSidebar}/>
                            <SidebarLink title='San Fernando' route='/prioritarios/sanfernando'
                                         onClick={this.hideSidebar}/>
                            <SidebarLink title='Kimberly' route='/prioritarios/kimberly'
                                         onClick={this.hideSidebar}/>
                            <SidebarLink title='Nexo' route='/prioritarios/nexo'
                                         onClick={this.hideSidebar}/>
                            <SidebarLink title='Stanley' route='/prioritarios/stanley'
                                         onClick={this.hideSidebar}/>
                            <SidebarLink title='Auren 2' route='/prioritarios/auren2'
                                         onClick={this.hideSidebar}/>
                        </ul>
                        <ul className='sidebar__block'>
                            <SidebarLink title='Configuración' route='/prioritarios/configuracion'
                                         onClick={this.hideSidebar}/>
                            <SidebarLink title='Tienda Pago' route='/prioritarios/tiendapago'
                                         onClick={this.hideSidebar}/>
                        </ul>
                    </SidebarCategory>
                    <SidebarLink title='Rechazos' icon='layers' route='/rechazos' onClick={this.hideSidebar}/>
                    <SidebarCategory title='Stock' icon='layers'>
                        <SidebarLink title='Gloria' route='/stock/gloria' onClick={this.hideSidebar}/>
                        <SidebarLink title='Detallado' route='/stock/producto' onClick={this.hideSidebar}/>
                    </SidebarCategory>
                    <SidebarLink title='T2' icon='layers' route='/t2' onClick={this.hideSidebar}/>
                    <SidebarCategory title='Visicoolers' icon='layers'>
                        <SidebarCategory title='Gloria'>
                            <ul className='sidebar__block'>
                                <SidebarLink title='Asignados' route='/visicoolers/gl/asignados'
                                             onClick={this.hideSidebar}/>
                                <SidebarLink title='Modelos' route='/visicoolers/gl/modelos'
                                             onClick={this.hideSidebar}/>
                            </ul>
                            <ul className='sidebar__block'>
                                <SidebarLink title='Asignar' route='/visicoolers/gl/asignar'
                                             onClick={this.hideSidebar}/>
                            </ul>
                        </SidebarCategory>
                        <SidebarCategory title='San Fernando' icon='layers'>
                            <ul className='sidebar__block'>
                                <SidebarLink title='Asignados' route='/visicoolers/sf/asignados'
                                             onClick={this.hideSidebar}/>
                            </ul>
                            <ul className='sidebar__block'>
                                <SidebarLink title='Asignar' route='/visicoolers/sf/asignar'
                                             onClick={this.hideSidebar}/>
                            </ul>
                            <ul className='sidebar__block'>
                                <SidebarLink title='Cuotas' route='/visicoolers/sf/cuotas'
                                             onClick={this.hideSidebar}/>
                            </ul>
                        </SidebarCategory>
                    </SidebarCategory>
                    <SidebarCategory title='Celulares' icon='layers'>
                        <ul className='sidebar__block'>
                            <SidebarLink title='Avance x Zonal' route='/celulares/zonales'
                                         onClick={this.hideSidebar}/>
                        </ul>
                        <ul className='sidebar__block'>
                            <SidebarLink title='Avance x PDV' route='/celulares/pdvs'
                                         onClick={this.hideSidebar}/>
                        </ul>
                        <ul className='sidebar__block'>
                            <SidebarLink title='Cargar data' route='/celulares/zonales/data'
                                         onClick={this.hideSidebar}/>
                        </ul>
                    </SidebarCategory>
                </ul>
            </div>
        )
    }
}

export default SidebarContent;


// WEBPACK FOOTER //
// ./src/components/common/layout/topbar_with_navigation/sidebar_mobile/sidebar-content.tsx